import * as React from "react"

const RectSvg = (props) => {
	const color = props.color || "#48D6D2"

	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="14" height="14" fill={color} />
		</svg>
	)
}

const PinkRect = () => (
	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="14" height="14" fill="#E37DB2" />
	</svg>
)

export { RectSvg, PinkRect }
